import { pick } from 'lodash';
import QueryString from 'qs';
import type {
  LocationQuery,
  LocationQueryRaw,
  NavigationGuardReturn,
  RouteLocationNormalized,
  RouterOptions,
} from 'vue-router';

export const preserveQueryParams = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): NavigationGuardReturn => {
  const toParts = (to.name as string)?.split('.') || [];
  const fromParts = (from.name as string)?.split('.') || [];
  const isSameScope = toParts[0] === fromParts[0];

  const fromQueryKeys = Object.keys(from.query);
  const toQueryKeys = Object.keys(to.query);
  const hasAllFromQueryKeys = fromQueryKeys.every((key) => toQueryKeys.includes(key));

  if (isSameScope && fromQueryKeys.length && !hasAllFromQueryKeys) {
    return { ...to, query: { ...from.query, ...to.query } };
  }
};

export const defaultRouterOptions: Partial<RouterOptions> = {
  parseQuery: (value: string) => {
    return QueryString.parse(value) as LocationQuery;
  },
  stringifyQuery: (query: LocationQueryRaw | undefined) => {
    const safeQuery = query ?? {};

    const sortedQuery = pick(safeQuery, [
      'per_page',
      'page',
      'sort',
      ...Object.keys(safeQuery).sort(),
      'view',
    ]);
    return QueryString.stringify(sortedQuery, { encode: false }) as string;
  },
};
